const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_616_2292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 22,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4428 2.63184H2.13867V23.9652H23.4428V2.63184Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_616_2292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7746 21.7953L3.90798 12.9283V7.45588L6.93507 4.42879H18.6142L21.6413 7.45588V12.9283L12.7746 21.7953ZM23.1552 6.46197L19.6084 2.91524C19.4425 2.74842 19.217 2.65497 18.9816 2.65527H6.56825C6.33264 2.65497 6.10707 2.74873 5.94146 2.91585L2.39474 6.46197C2.22792 6.62818 2.13446 6.85375 2.13477 7.08906V13.2958C2.13477 13.5405 2.23401 13.7621 2.39474 13.9235L12.1482 23.676C12.3141 23.8428 12.5396 23.9369 12.775 23.9369C13.0103 23.9369 13.2358 23.8431 13.4017 23.676L23.1552 13.9226C23.3156 13.7621 23.4151 13.5405 23.4151 13.2958V7.08906C23.4151 6.85375 23.3217 6.62818 23.1552 6.46197Z",
    fill: "#181818",
    style: {
      fill: "#181818",
      fill: "color(display-p3 0.0941 0.0941 0.0941)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.0933 7.97656H7.45312V9.74977H18.0933V7.97656Z",
    fill: "#181818",
    style: {
      fill: "#181818",
      fill: "color(display-p3 0.0941 0.0941 0.0941)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconService);
export default __webpack_public_path__ + "static/media/icon-service.f5384ed1ef43ce0ab2d79753ee881397.svg";
export { ForwardRef as ReactComponent };